

import { baseApi } from './baseApi'

export const dashboardAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_dashboardAttendance: builder.query<any, any>({
      query: (params) => ({
        url: '/attendance/stats/',
        params,
      }),
      providesTags: ['dashboard-attendance'],
    }),
    GET_dashboardGradebookAssessments: builder.query<any, any>({
      query: (params) => ({
        url: '/gradebook-assessments/stats/',
        params,
      }),
      providesTags: ['dashboard-grades'],
    }),
    GET_dashboardStudents: builder.query<any, any>({
      query: (params) => ({
        url: '/students/stats/',
        params,
      }),
      providesTags: ['dashboard-students'],
    }),
    GET_dashboardTeachers: builder.query<any, any>({
      query: (params) => ({
        url: '/teachers/stats/',
        params,
      }),
      providesTags: ['dashboard-teachers'],
    }),
    GET_dashboardTotals: builder.query<any, void>({
      query: () => ({
        url: '/total-user-counts/',
      }),
      providesTags: ['dashboard-totals'],
    }),
  }),
})

export const {
  useGET_dashboardAttendanceQuery,
  useGET_dashboardGradebookAssessmentsQuery,
  useGET_dashboardStudentsQuery,
  useGET_dashboardTeachersQuery,
  useGET_dashboardTotalsQuery,
} = dashboardAPI
